import { ViewerComponent } from "./Landing";

const OperatingRegulations = () => {
    return   <div style={{ marginTop: 0, backgroundColor: '#fff', paddingTop: '20px', height: '100vh', borderRadius: '10px' }}>
        <div style={{display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 10}}><span>Quy chế hoạt động</span></div>
          <ViewerComponent fileUrl={'pdf/quy-che-hoat-dong.pdf'} />
     </div>
}

export default OperatingRegulations;